export const DEPRECIATION_ITEMS_TEMPLATE_URL =
  'https://storage.googleapis.com/cashy-api-v2-content/templates/Depreciation_Template.xlsx'
